<template>
  <div name="hrms-dropdown-year">
    <hrms-dropdown  v-model="inputValue"
                    :options="objYear[nowLang]"
                    :disabled="disabled"
                    :showNone="false" />
  </div>
</template>

<script>
import moment from 'moment'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms-dropdown-year',
  data () {
    return {
      dispMinYear: this.minYear,
      dispMaxYear: this.maxYear,
      inputValue: 'a' + this.value,
      objYear: '',
      additionalYear: assetsUtils.getAdditionalYear()
    }
  },
  created () {
    this.objYear = this.genYear()
  },
  watch: {
    value () {
      this.inputValue = 'a' + this.value
    },
    inputValue () {
      if (this.inputValue === undefined) {
        this.inputValue = moment().year()
      }
      let strInputValue = '' + this.inputValue
      this.$emit('input', strInputValue.replace('a', ''))
      if (this.inputValue !== null) {
        this.objYear = this.genYear()
      }
    }
  },
  props: {
    value: {
      type: [String, Number],
      default () {
        return moment().year()
      }
    },
    minYear: {
      type: Number,
      default: moment().year() - 50
    },
    maxYear: {
      type: Number,
      default: moment().year() + 10
    },
    nowLang: {
      type: String,
      default: 'en'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    genYear () {
      let objYear = {}
      let amountDisplay = 50
      let strInputValue = '' + this.inputValue
      let maxDisp = Math.min(this.maxYear, this.dispMaxYear, parseInt(strInputValue.replace('a', '')) + (amountDisplay / 2))
      let minDisp = Math.max(this.minYear, this.dispMinYear, parseInt(maxDisp) - amountDisplay)
      if (maxDisp - minDisp < amountDisplay) {
        maxDisp = Math.min(this.maxYear, minDisp + amountDisplay)
      }
      for (let i = maxDisp; i >= minDisp; i--) {
        objYear['a' + i] = i + parseInt(this.additionalYear)
      }

      return {
        th: objYear,
        en: objYear
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?78256aee